import React from "react";
import { BottomNavigation, BottomNavigationAction } from "@material-ui/core";
import FooterProps from "./Footer.types";
import Attendance from "../SVG/Attendance";
import Pile from "../SVG/Pile";
import Profile from "../SVG/Profile";

const Footer = (props: FooterProps) => {
  const [value, setValue] = React.useState(0);
  return (
    <BottomNavigation
      showLabels
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
      }}
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
      }}
    >
      <BottomNavigationAction
        label="Attendance"
        onClick={() => {
          console.log("attendance");
        }}
        icon={<Attendance isActive={value === 0} />}
      />
      <BottomNavigationAction
        label="Pile"
        onClick={() => {
          console.log("pile");
        }}
        icon={<Pile isActive={value === 1} />}
      />
      <BottomNavigationAction
        label="Profile"
        onClick={() => {
          console.log("profile");
        }}
        icon={<Profile isActive={value === 2} />}
      />
    </BottomNavigation>
  );
};

export default Footer;
